// https://element.eleme.cn/#/zh-CN/component/progress
// 参考element-ui progress
<template>
  <div :style="{height: width + 'px', width: width + 'px'}">
    <svg viewBox="0 0 100 100">
      <path
        :d="trackPath"
        :stroke="color"
        :stroke-width="relativeStrokeWidth"
        fill="none"
        :style="trailPathStyle"></path>
      <path
        :d="trackPath"
        :stroke="stokeColor"
        fill="none"
        stroke-linecap="round"
        :stroke-width="percentage ? relativeStrokeWidth : 0"
        :style="circlePathStyle"></path>
    </svg>
  </div>
</template>
<script>
import mixins from '@/utils/mixins'
export default {
  name: 'CircleProgress',
  mixins: [mixins],
  props: {
    percentage: {
      type: Number,
      default: 0,
      required: true,
      validator: val => val >= 0 && val <= 100
    },
    strokeWidth: {
      type: Number,
      default: 2
    },
    width: {
      type: Number,
      default: 22.5
    },
    color: {
      type: String,
      default: '#e5e9f2'
    },
    stokeColor: {
      type: String,
      default: '#009cde'
    }
  },
  computed: {
    relativeStrokeWidth () {
      return (this.strokeWidth / this.width * 100).toFixed(1)
    },
    radius () {
      return parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10)
    },
    trackPath () {
      const radius = this.radius
      return `
        M 50 50
        m 0 -${radius}
        a ${radius} ${radius} 0 1 1 0 ${radius * 2}
        a ${radius} ${radius} 0 1 1 0 -${radius * 2}
        `
    },
    perimeter () {
      return 2 * Math.PI * this.radius
    },
    rate () {
      return 1
    },
    strokeDashoffset () {
      const offset = -1 * this.perimeter * (1 - this.rate) / 2
      return `${offset}px`
    },
    trailPathStyle () {
      return {
        strokeDasharray: `${this.perimeter * this.rate}px, ${this.perimeter}px`,
        strokeDashoffset: this.strokeDashoffset
      }
    },
    circlePathStyle () {
      return {
        strokeDasharray:
        `${this.perimeter * this.rate * (this.percentage / 100)}px, ${this.perimeter}px`,
        strokeDashoffset: this.strokeDashoffset,
        transition: 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'
      }
    }
  }
}
</script>
